import React from 'react';
import { useOneButtonStore } from '../../../../store/oneButtonStore';
import './oneButton-css/FinancePartnerSyncModal.css';
import './oneButton-css/CommerceHubPanel.css';

export interface CommerceHubPanelProps {
    salesForceId?: string | null | undefined;
    loading?: boolean;
    onSolarPricingClick?: () => void;
    opportunityNumericId?: string | number | null | undefined;
    priceQuote?: unknown;
    children?: React.ReactNode;
}

/** Inline commerce hub shell. Pass partner checklist (or other commerce body) as children. */
export const CommerceHubPanel: React.FC<CommerceHubPanelProps> = ({ children }) => {
    const theme = useOneButtonStore((s) => s.theme);

    return <div className={`obd-commerce-hub obd-theme-${theme}`}>{children}</div>;
};

export default CommerceHubPanel;
